import { type TranslationTree } from '@/i18n/types';

export const messages = {
  enable: 'Oferecer cupom',
  enableHint: 'Um código de desconto que o atleta copia no app',
  code: 'Código do cupom',
  codePlaceholder: 'Ex.: BODYPRINT20',
  codeHint: {
    withLink: 'Com o botão de site, o app copia o código e abre a loja.',
    atCounter: 'Sem botões, o atleta mostra o código no caixa.',
    default: 'O código aparece no card, pronto para copiar.',
  },
  terms: 'Regras do cupom',
  optional: 'opcional',
  termsPlaceholder: 'Ex.: Mínimo de R$ 100. Não vale com outras promoções.',
  termsHint: 'O app mostra as regras embaixo do cupom, com a data de fim da campanha.',
} satisfies TranslationTree;
